// @ts-nocheck
import React from 'react';
import { saveAs } from 'file-saver';
import ExcelJS from 'exceljs';

const ExportToExcel = ({ overallUptimePercentage, locations, uptimePercentageByLocation, currentYear }) => {
  const fileExtension = '.xlsx';

  const exportToExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('data');

    // Add Year and Overall Uptime
    worksheet.addRow(["Year", "Overall Uptime Percentage"]);
    worksheet.addRow([currentYear, overallUptimePercentage]);

    // Add empty row
    worksheet.addRow([]);

    // Add Location headers
    worksheet.addRow(["Location", "Uptime"]);

    // Add location data
    locations.forEach(location => {
      worksheet.addRow([location, uptimePercentageByLocation[location] + '%']);
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const data = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
    saveAs(data, 'UptimeReport' + currentYear + fileExtension);
  };

  return (
    <button 
      onClick={exportToExcel} 
      style={{
        position: 'relative', 
        borderRadius: '20px',
        padding: '10px 20px', 
        border: 'none',
        cursor: 'pointer',
        background: '#061ab1',
        color: 'white',
        fontWeight: 'bold',
        textTransform: 'uppercase'
      }}
    >
      Export
    </button>
  );
};

export default ExportToExcel;